import React from 'react'
import PropTypes from 'prop-types'

import { GlgModal } from 'Shared/components'

const BaseCloningModal = ({
  title,
  content,
  leftButton = null,
  rightButton = null,
}) => {
  return (
    <GlgModal onClose={() => {}} contentClassName={'cls-steps-modal'}>
        <span className={'title-container'}>{title}</span>
        <span className={'content-container'}>{content}</span>
        <span className={'buttons-container'}>
          {leftButton}
          {rightButton}
        </span>
    </GlgModal>
  )
}

BaseCloningModal.propTypes = {
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  leftButton: PropTypes.node,
  rightButton: PropTypes.node,
}

export default BaseCloningModal
